import React from "react";

const ErrorPage = () => {
  return (
    <div className="d-flex flex-column justify-content-center align-items-center text-center vh-100">
      <h4>404 Error</h4>
      <p>The page you are looking for could not be found.</p>
    </div>
  );
};

export default ErrorPage;
